import { Star, Quote } from "lucide-react";
import { useReviews } from "@/lib/queries";
import SectionHeading from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

export default function ReviewsSection() {
  const { data: reviews = [] } = useReviews();
  if (!reviews.length) return null;

  return (
    <section data-testid="reviews-section" className="bg-black py-24 sm:py-32">
      <div className="container-x">
        <SectionHeading
          number="06"
          overline="Müşteri Yorumları"
          title="Bizi tercih edenler ne diyor?"
          subtitle="Google ve müşteri değerlendirmelerinden bir seçki."
          align="center"
        />
        <div className="mt-14 grid gap-3 md:grid-cols-2 lg:grid-cols-3">
          {reviews.map((r, i) => (
            <Reveal key={r.id || i} delay={(i % 3) * 0.08}>
              <div className="flex h-full flex-col border border-white/10 bg-white/[0.02] p-7 transition-colors hover:border-gold/30">
                <div className="flex items-center justify-between">
                  <span className="flex gap-0.5">{[...Array(r.rating || 5)].map((_, k) => <Star key={k} className="h-4 w-4 fill-gold text-gold" />)}</span>
                  <Quote className="h-7 w-7 text-gold/25" />
                </div>
                <p className="mt-5 flex-1 text-sm leading-relaxed text-neutral-300">"{r.text}"</p>
                <div className="mt-6 flex items-center gap-3 border-t border-white/10 pt-5">
                  <span className="flex h-10 w-10 items-center justify-center border border-gold/30 bg-gold/10 font-display font-semibold text-gold">
                    {(r.name || "?").charAt(0)}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-white">{r.name}</p>
                    <p className="text-xs text-neutral-500">{r.car} {r.source ? `• ${r.source}` : ""}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
